import { memo } from 'react';
import { Bot, Database, LayoutGrid, Settings, Shield } from 'lucide-react';

/** Icon and tint of each studio of the catalog (`icon` key); an unknown key gets a neutral grid. */
const STUDIOS = Object.freeze({
  shield: { Icon: Shield, tint: 'bg-emerald-500/10 text-emerald-400' },
  database: { Icon: Database, tint: 'bg-sky-500/10 text-sky-400' },
  bot: { Icon: Bot, tint: 'bg-purple-500/10 text-purple-400' },
  settings: { Icon: Settings, tint: 'bg-blue-500/10 text-blue-400' },
});
const FALLBACK = { Icon: LayoutGrid, tint: 'bg-surface-muted text-content-secondary' };

/** Icon of a studio from the catalog's `icon` key, tinted like the prototype. */
const StudioIcon = ({ icon }) => {
  const { Icon, tint } = STUDIOS[icon] ?? FALLBACK;
  return (
    <span className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-lg ${tint}`}>
      <Icon size={18} aria-hidden />
    </span>
  );
};

export default memo(StudioIcon);
